





















import { Component, Mixins } from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';
import bNavText from 'bootstrap-vue/es/components/nav/nav-text';

import TopnavNav from './TopnavNav';

@Component({
  components: {
    bButton,
    bNavText,
  },
})
export default class NavLink extends Mixins(TopnavNav) { }

